<template>
  <div class="page flex-col">
    <ServiceCasesWidget v-if="select === 0" :data="loopData0" @select="handleSelect" />
    <CaseWidget v-else :data="selectData" @select="handleSelect" />
  </div>
</template>
<script>
import ServiceCasesWidget from '@/views/service_case/components/ServiceCasesWidget.vue'
import CaseWidget from '@/views/service_case/components/CaseWidget/index.vue'
import JD from './assets/img/jd.webp'
import SQ from './assets/img/sq.webp'
import DX from './assets/img/dx.webp'
import JS from './assets/img/js.webp'
import ZK from './assets/img/zk.webp'
import BD from './assets/img/bd.webp'
import HB from './assets/img/hb.webp'
import NC from './assets/img/nc.webp'
import HL from './assets/img/hl.webp'
import JD1 from './assets/img/jd/img1.webp'
import JD2 from './assets/img/jd/img2.webp'
import JD3 from './assets/img/jd/img3.webp'
import JD4 from './assets/img/jd/img4.webp'
import JD5 from './assets/img/jd/img5.webp'
import JD6 from './assets/img/jd/img6.webp'
import JD7 from './assets/img/jd/img7.webp'
import JD8 from './assets/img/jd/img8.webp'
import JD9 from './assets/img/jd/img9.webp'
import DX1 from './assets/img/dx/img1.webp'
import DX2 from './assets/img/dx/img2.webp'
import DX3 from './assets/img/dx/img3.webp'
import DX4 from './assets/img/dx/img4.webp'
import DX5 from './assets/img/dx/img5.webp'
import DX6 from './assets/img/dx/img6.webp'
import DX7 from './assets/img/dx/img7.webp'
import DX8 from './assets/img/dx/img8.webp'
import DX9 from './assets/img/dx/img9.webp'
import HBKJ1 from './assets/img/hbkj/img1.webp'
import HBKJ2 from './assets/img/hbkj/img2.webp'
import HBKJ3 from './assets/img/hbkj/img3.webp'
import HBKJ4 from './assets/img/hbkj/img4.webp'
import HBKJ5 from './assets/img/hbkj/img5.webp'
import HBKJ6 from './assets/img/hbkj/img6.webp'
import HBKJ7 from './assets/img/hbkj/img7.webp'
import HBKJ8 from './assets/img/hbkj/img8.webp'
import HBKJ9 from './assets/img/hbkj/img9.webp'
import LG1 from './assets/img/lg/img1.webp'
import LG2 from './assets/img/lg/img2.webp'
import LG3 from './assets/img/lg/img3.webp'
import LG4 from './assets/img/lg/img4.webp'
import LG5 from './assets/img/lg/img5.webp'
import LG6 from './assets/img/lg/img6.webp'
import LG7 from './assets/img/lg/img7.webp'
import LG8 from './assets/img/lg/img8.webp'
import LG9 from './assets/img/lg/img9.webp'
import NC1 from './assets/img/nc/img1.webp'
import NC2 from './assets/img/nc/img2.webp'
import NC3 from './assets/img/nc/img3.webp'
import NC4 from './assets/img/nc/img4.webp'
import NC5 from './assets/img/nc/img5.webp'
import NC6 from './assets/img/nc/img6.webp'
import NC7 from './assets/img/nc/img7.webp'
import NC8 from './assets/img/nc/img8.webp'
import NC9 from './assets/img/nc/img9.webp'
import WXHY1 from './assets/img/wxhy/img1.webp'
import WXHY2 from './assets/img/wxhy/img2.webp'
import WXHY3 from './assets/img/wxhy/img3.webp'
import WXHY4 from './assets/img/wxhy/img4.webp'
import WXHY5 from './assets/img/wxhy/img5.webp'
import WXHY6 from './assets/img/wxhy/img6.webp'
import WXHY7 from './assets/img/wxhy/img7.webp'
import WXHY8 from './assets/img/wxhy/img8.webp'
import WXHY9 from './assets/img/wxhy/img9.webp'
import ZD1 from './assets/img/zd/img1.webp'
import ZD2 from './assets/img/zd/img2.webp'
import ZD3 from './assets/img/zd/img3.webp'
import ZD4 from './assets/img/zd/img4.webp'
import ZD5 from './assets/img/zd/img5.webp'
import ZD6 from './assets/img/zd/img6.webp'
import ZD7 from './assets/img/zd/img7.webp'
import ZD8 from './assets/img/zd/img8.webp'
import ZD9 from './assets/img/zd/img9.webp'
import ZK1 from './assets/img/zk/img1.webp'
import ZK2 from './assets/img/zk/img2.webp'
import ZK3 from './assets/img/zk/img3.webp'
import ZK4 from './assets/img/zk/img4.webp'
import ZK5 from './assets/img/zk/img5.webp'
import ZK6 from './assets/img/zk/img6.webp'
import ZK7 from './assets/img/zk/img7.webp'
import ZK8 from './assets/img/zk/img8.webp'
import ZK9 from './assets/img/zk/img9.webp'
import ZYY1 from './assets/img/zyy/img1.webp'
import ZYY2 from './assets/img/zyy/img2.webp'
import ZYY3 from './assets/img/zyy/img3.webp'
import ZYY4 from './assets/img/zyy/img4.webp'
import ZYY5 from './assets/img/zyy/img5.webp'
import ZYY6 from './assets/img/zyy/img6.webp'
import ZYY7 from './assets/img/zyy/img7.webp'
import ZYY8 from './assets/img/zyy/img8.webp'
import ZYY9 from './assets/img/zyy/img9.webp'

  export default {
  components: {
    ServiceCasesWidget,
    CaseWidget
  },
  data() {
    return {
      loopData0: [
        {
          lanhuBg0: JD,
          lanhutext0: '重庆机电职业技术大学',
          lanhutext1: '地址：重庆市璧山区璧泉街道1001号',
          describeList: [
            '重庆机电职业技术大学是一所民办大学，位于重庆市西部地区一璧山，是重庆市骨干高职院校、全国首批本科层次职业学校改革试点单位、重庆市首个中国人民解放军定向培养士官高校。校园占地约2800亩，建筑面积36万平方米，学校下设11个学院,开设17个职业本科专业，41个专科专业。现有教职工 940 人，专本科学生共计 20938 人。',
            '公司经营项目包括学校商业、超市以及食堂。其中商业面积 2.2万平米，超市面积 650平米，食堂面积 2000平米，项目投放固定设施 2 部观光电梯、商业环境改造放置休闲桌椅、安装氛围路灯。该项目周边无商业。'],
          photoList: [JD1, JD2, JD3, JD4, JD5, JD6, JD7, JD8, JD9],
          index: 1
        },
        {
          lanhuBg0: SQ,
          lanhutext0: '宿迁泽达职业技术学院',
          lanhutext1: '地址：江苏省宿迁市宿豫区学成路66号',
          describeList: [
              '宿迁泽达职业技术学院是一所一所经江苏省人民政府批准、教育部备案、独立设置专科层次的全日制普通高校，学校坐落于江苏省宿迁市湖滨新区，学校规划总占地面积856亩，目前占地面积为513亩，有校舍建筑面积 14万余平方米，下设28个专业。现有教职工460余人，在校生8000余人。学校实行半军事化管理，学生每周末可回家。',
              '公司经营项目包括学校商业、超市以及食堂，其中商业面积 2000平方，校内3家独家超市经营，面积 1000平方，3个食堂面积10000平方。项目为其校方修建路面，打造商业环境放置休闲桌椅、安装氛围路灯等，为师生提高在校就读工作舒适感。'
          ],
          photoList: [ZD1, ZD2, ZD3, ZD4, ZD5, ZD6, ZD7, ZD8, ZD9],
          index: 2
        },
        {
          lanhuBg0: DX,
          lanhutext0: '重庆电讯职业学院',
          lanhutext1: '地址：重庆市江津区双福街道学府路65号',
          describeList: [
              '重庆电讯职业学院是一所军企教融合发展的技术型的、经堂庆市人民政府批准、教育部备案面向全国招生的全日制普通民办高等院校，学校位于堂庆市江津双福新区学府路65号，规划总占地1350亩，总体规划建筑面积 44万平方米，现设置有 40个专业，学校现有专、兼职教师883人，其中专任教师579人，在校生规模2万余人。学校传承了军事院校成功的办学经验和管理模式。',
              '公司经营项目包括学校商业、超市，其中商业面积2600平米，引进德克士、瑞幸咖啡等品牌客户；2个超市总面积680平米，项目投放固定设施2部观光电梯以及休闲桌椅。'
          ],
          photoList: [DX1, DX2,DX3, DX4, DX5, DX6, DX7, DX8, DX9],
          index: 3
        },
        {
          lanhuBg0: JS,
          lanhutext0: '无锡宏源技师学院',
          lanhutext1: '地址：江苏省无锡市锡山区春晖东路153号',
          describeList: [
              '无锡宏源技师学院是一所民办职业院校，学院地处太湖之畔的江南名城无锡。学院以培养效控、机电、模具、计算机等专业高技能人才为主的一所技工院校，是无锡市经江苏省人民政府批准的具备开设技师班资质的学院之一，学院下设5个二级院系、12个专业，现有4000余人。学校实行半军事化管理，周边附近无商业，处于工业园区中。',
              '公司经营项目包括学校商业、超市、食堂以及部分校园配套一快递柜的投放。其中商业面积200平米；校内独家超市经营，面积220平方，处于宿舍楼下，位置优越；食堂面积 1500平方。'
          ],
          photoList: [WXHY1, WXHY2, WXHY3, WXHY4, WXHY5, WXHY6, WXHY7, WXHY8, WXHY9],
          index: 4
        },
        {
          lanhuBg0: ZK,
          lanhutext0: '周口师范学院',
          lanhutext1: '地址：河南省周口市川汇区文昌大道中段6号',
          describeList: [
              '周口师范学院是一所普通本科高校，学院地处历史文化名城周口市，占地1600 余亩，建筑面积76万平方米，学院下设20个教学院（部），65个本科专业，现有教职工1727人，专任教师1283人，全日制在校生25041人。',
              '公司经营学校商业、超市，面积 1000平方，其中商业与超市一体化，引进蜜雪冰城等品牌客户，让学生在逛超市的同时也能感受集生活零售、水果、水吧等多元业态于一体的商业配套。'
          ],
          photoList: [ZK1, ZK2, ZK3, ZK4, ZK5, ZK6, ZK7, ZK8, ZK9],
          index: 5
        },
        {
          lanhuBg0: BD,
          lanhutext0: '保定理工学院',
          lanhutext1: '地址：河北省保定市南二环1689号',
          describeList: [
              '保定理工学院是一所由中国地质大学（北京）与保定贺阳教育投资有限公司合作举办的一所民办全日制普通本科独立学院，学院地处河北省保定市，占地面积114.12万平方米，建筑总面积53.4万平方米，学院下设9个二级教学单位，42个本科专业，在校生的数量为3万余人，学院实行准军校式管理，形成了以地学为特色，工科为主体，与河北科技学院紧邻。',
              '公司经营项目包括学校商业、超市，其中商业面积600平米，超市面积 400平米，商业和超市实行一体化，引进重庆文化一火锅与北方饮食进行交流和碰撞，从中起到宣传和引流的左右。'
          ],
          photoList: [LG1, LG2, LG3, LG4, LG5, LG6, LG7, LG8, LG9],
          index: 6
        },
        {
          lanhuBg0: HB,
          lanhutext0: '河北科技学院',
          lanhutext1: '地址：河北保定市南二环路1956号',
          describeList: [
              '河北科技学院由贺阳教育投资有限公司创办，隶属于河北省教育厅，是经教育部批准设立的普通民办本科高等院校，学院地处河北省保定市。学校占地2800亩，总建筑面积110万平方米，学院下设9个二级学院，40个本科专业，30个专科专业，涵盖工、管、经、艺、教、医等6大学科门类。现有教职工1780人，专任教师1342人，在校学生 25928人。学院实行准车校式管理，实行周假。',
              '公司主营学校超市，校内经营2家超市，面积 800平米，其中一家位于学生宿舍楼之间，一家位于教学楼旁，地理位置优越，兼顾了师生下课、休息、娱乐等时间，更好的便捷了生活。'
          ],
          photoList: [HBKJ1, HBKJ2, HBKJ3, HBKJ4, HBKJ5, HBKJ6, HBKJ7, HBKJ8, HBKJ9],
          index: 7
        },
        {
          lanhuBg0: NC,
          lanhutext0: '南昌大学共青学院',
          lanhutext1: '地址：江西省九江市共青城市南湖大道50号',
          describeList: [
              '南昌大学共青学院是一所以工为主，经、管、文等多学科协调发展的民办本科独立高校，学院地处地处庐山南 ，鄱湖之畔⋯江西省共青城市，占地面积 1014亩，学院下设专业34个，其中本科招生专业18个，专科专业12个，有教职工436 人，本专科学生10535人。',
              '公司主营学校超市，承接校内3个超市，面积总，200平米，分别处于学生宿舍楼下、食堂内、商业街内。'
          ],
          photoList: [NC1, NC2, NC3, NC4, NC5, NC6, NC7, NC8, NC9],
          index: 8
        },
        {
          lanhuBg0: HL,
          lanhutext0: '湖南中医药大学湘杏学院',
          lanhutext1: '地址：湖南省岳阳市湘阴县金龙镇芙蓉北路湘阴',
          describeList: [
              '湖南中医药大学湘杏学院是由湖南中医药大学按新机制、新模式举办的全日制本科独立学院。系湖南中医药大学属下的二级法人机构，学院地处湖南省岳阳市湘阴县金龙镇芙蓉北路湘阴段66号。学校占地面积1500亩，学院下设13个本科专业，4大学科门类，现有在校学生5700余人，校区全部工程完工后，可同时容纳15000名学生就读。远期在校学生和教职员工50000人+师生在此学习生活。',
              '公司整体升级打造，率先进行超市、汉堡王、菜鸟驿站等主力业态布局，利用大型超市落地，主力业态签约，固定投放2台扶梯，提高进入便捷性，提升引流效果，周边无大型商业。'
          ],
          photoList: [ZYY1, ZYY2, ZYY3, ZYY4, ZYY5, ZYY6, ZYY7, ZYY8, ZYY9],
          index: 9
        }
      ],
      select: 0,
      selectData: {},
      constants: {}
    };
  },
  mounted() {
    if (this.$route.query?.select) {
      const select = Number(this.$route.query?.select);
      this.select = select
      if (select !== 0) {
        this.loopData0.forEach((item) => {
          if (item.index === select) {
            this.selectData = item;
          }
        })
      } else {
        this.selectData = {};
      }
    }
  },
  methods: {
    handleSelect(value) {
      this.select = value;
      if (value !== 0) {
        this.loopData0.forEach((item) => {
          if (item.index === value) {
            this.selectData = item;
          }
        })
      } else {
        this.selectData = {};
      }
      window.scrollTo(0,0);
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
